import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../../supabase';

const Leads = () => {
  const { id } = useParams()

  const [funnelData, setFunnelData] = useState(null);
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const fetchFunnel = async () => {
      const { data, error } = await supabase
        .from('funnels')
        .select('*')
        .eq('uuid', id);
      setFunnelData(data[0]);
    }
    fetchFunnel();

    const fetchLeads = async () => {
      const { data, error } = await supabase
        .from('funnel_interactions')
        .select('*')
        .eq('funnel_uuid', id);

      console.log(data);
      setLeads(data);
    }
    fetchLeads();
  }, [id]);



  const getStatusBadge = (status) => {
    const statusStyles = {
      Hot: 'bg-red-100 text-red-800 border-red-200',
      Warm: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      Cold: 'bg-blue-100 text-blue-800 border-blue-200'
    }
    
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium border ${statusStyles[status]}`}>
        {status}
      </span>
    )
  }
  if(!funnelData) return <div>Carregando...</div>
   
  return (
    <div className="   min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Funnel: {funnelData?.title}</h1>
        <p className="text-gray-600">Leads e Interações</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold text-gray-900">All Leads ({leads.length})</h2>
           
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-900 uppercase tracking-wider">
                  Data
                </th>
                {JSON.parse(funnelData?.funnel).map((step, index) => (
                  console.log(step),
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-900 uppercase tracking-wider">
                    {step.title} ({index == 0 ? funnelData.visits : step.visits})
                  </th>
                ))}
                
                
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-900 uppercase tracking-wider">
                  Tracking
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {leads.map((lead) => (
                <tr key={lead.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div>
                      <div className="text-sm font-medium text-gray-900">
                        {(() => {
                          const date = new Date(lead.created_at);
                          const dateStr = date.toLocaleDateString('pt-BR');
                          const timeStr = date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
                          return `${dateStr} ${timeStr}`;
                        })()}
                      </div>
                     
                    </div>
                  </td>
                  {JSON.parse(funnelData?.funnel).map((step, index) => (
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{(lead?.choices[step.title]?.optionTitle || '').replace(/<[^>]*>/g, '')}</div>
                      <div className="text-sm text-gray-900">
                        {lead?.choices[step.title]?.values && Array.isArray(lead.choices[step.title].values) && lead.choices[step.title].values.map((value, index) => {
                          // If value is an object, display its key and value, else display as string
                          if (typeof value === 'object' && value !== null) {
                            // Show all key-value pairs in the object
                            return Object.entries(value).map(([k, v], i) => (
                              <div className="text-sm text-gray-900" key={index + '-' + k}>
                                 {v}
                              </div>
                            ));
                          } else {
                            // Fallback: just show the value
                            return (
                              <div className="text-sm text-gray-900" key={index}>
                                {value}
                              </div>
                            );
                          }
                        })}
                      </div>
                    </td>
                  ))}
                  
                  
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">{lead.tracking}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

  
    </div>
  )
}

export default Leads